module.exports = __webpack_public_path__ + "img/no-avatar-job-opportunity.64719e4d.svg";